import { render, staticRenderFns } from "./dialog-save-tongzhuren.vue?vue&type=template&id=6f344f84&scoped=true&"
import script from "./dialog-save-tongzhuren.vue?vue&type=script&lang=js&"
export * from "./dialog-save-tongzhuren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f344f84",
  null
  
)

export default component.exports